import { TradeOrder, updateTradeOrders } from '../reducer/strategyBuilder.reducer.ts'
import store from '../store'
import { getSecurityAsync, getSecurityKey } from './security.ts'

class PayoffManager {
    async setTrades(tradeOrders: TradeOrder[]) {
        const resolved = await Promise.all(tradeOrders.map(async (tradeOrder) => {
            const security = await getSecurityAsync(getSecurityKey(tradeOrder.security.exchange, tradeOrder.security.code))
            return { ...tradeOrder, security }
        }))
        store.dispatch(updateTradeOrders(resolved))
    }
}
export default PayoffManager
